module.exports = __webpack_public_path__ + "img/circle-phone-flip.b0cf68f2.svg";